<script module lang="ts">
  export {
    // eslint-disable-next-line no-import-assign
    showNotification,
    // eslint-disable-next-line no-import-assign
    showSystemNotification,
  } from './notifications.svelte.js'
</script>

<script lang="ts">
  import { browser } from '$app/env'
  import { page } from '$app/state'
  import type { TypedSupabaseClient } from '$lib/supabase'
  import { getSupabaseContext } from '$lib/supabase/context'
  import { onDestroy } from 'svelte'
  import { receive, send } from './transition'
  import { flip } from 'svelte/animate'
  import Toast from './Toast.svelte'
  import {
    notifications,
    showNotification,
    showSystemNotification,
  } from './notifications.svelte.js'

  let intervalId: number | undefined
  let session = $derived(page.data.session)

  const { supabase } = getSupabaseContext()

  const startPolling = () => {
    if (!browser) return
    window.clearInterval(intervalId)

    poll()
    intervalId = window.setInterval(poll, 60000)
  }

  const loadNotifications = async (
    supabase: TypedSupabaseClient,
    userId: string,
  ) => {
    if (!session) return
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .is('seen_at', null)
      .eq('user_uid', userId)
    //
    if (error) {
      showSystemNotification('Error fetching notifications')
      console.error(error)
      stopPolling()
      return
    }

    for (const notification of data) {
      showNotification(notification, {
        onDismiss: async () => {
          await supabase.rpc('mark_notification_seen', {
            _notification_id: notification.id,
          })
        },
      })
    }
  }
  const poll = async () => {
    if (!browser) return

    if (!session) return stopPolling()

    Promise.all([loadNotifications($supabase, session.user.id)])
  }

  const stopPolling = () => {
    if (!browser) return
    window.clearInterval(intervalId)
  }

  $effect(() => {
    if (session) {
      startPolling()
    } else {
      stopPolling()
    }
  })

  onDestroy(stopPolling)
</script>

<ul class="toaster">
  {#each notifications
    .entries()
    .filter(([_, n]) => n) as [id, notification] (id)}
    <li
      in:receive={{ key: id }}
      out:send={{ key: id }}
      animate:flip={{ duration: 200 }}
    >
      <Toast
        message={notification!.message}
        payload={notification!.payload}
        onDismiss={notification!.onDismiss}
      />
    </li>
  {/each}
</ul>

<style>
  .toaster {
    display: flex;
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 1000;
    margin: 0;
    padding: 0;
    list-style: none;
  }
</style>
